import { ViewFactory } from 'src/3rds/cube-react'

import { DashboardsScope } from '../Dashboards.scopes'
import DashboardsView from './Dashboards.view'

export { DashboardsView } from './Dashboards.view'

export function registerViews(rv = ViewFactory.register) {
    rv(DashboardsScope, DashboardsView)
}
